import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46c91530"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "border container-table bg-white my-5" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = {
  key: 1,
  class: "d-flex justify-space-between align-center mt-8 border-t pt-3"
}
const _hoisted_4 = { class: "d-flex align-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Resultados por página", -1))
const _hoisted_6 = { key: 0 }

import { IHeadersTable,  IItemTreeTable } from '@/types';
import { withDefaults, ref, watch, onMounted, computed } from 'vue';
import TreeTable from 'primevue/treetable';
import Column from 'primevue/column';
import { MoleculeFilters, MoleculePagination } from '@/components/molecules';
interface IProps {
  headers?: Array<IHeadersTable>;
  items?: IItemTreeTable[];
  filters?: boolean;
  enableOptions?: boolean;
  disableSelectInfo?: boolean;
  selectOnCheckboxOnly?: boolean;
  textEmpty?: string;
  selectedClass?: string;
  indexSelect?: number;
  perPage?: number;
  page?: number;
  totalItems?: number;
  update?: boolean;
  pagination?: boolean;
  loading?: boolean;
  itemSelect?: any;
  hasOptions?: boolean;
  // checkbox?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeTreeTable',
  props: {
    headers: {},
    items: {},
    filters: { type: Boolean, default: false },
    enableOptions: { type: Boolean },
    disableSelectInfo: { type: Boolean },
    selectOnCheckboxOnly: { type: Boolean },
    textEmpty: { default: 'No information to display' },
    selectedClass: { default: '' },
    indexSelect: {},
    perPage: { default: 10 },
    page: { default: 1 },
    totalItems: { default: 0 },
    update: { type: Boolean, default: false },
    pagination: { type: Boolean, default: true },
    loading: { type: Boolean },
    itemSelect: {},
    hasOptions: { type: Boolean, default: true }
  },
  emits: [
  'handleUpload',
  'rowClick',
  'changePerPage',
  'changePage',
  'updateRow',
  'searching',
  'handleSort',
  'blur',
],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
// const table = ref(null);

const search = ref<string>('');

const props = __props;
const lengthItems = computed(() => {
  return Math.ceil(props.totalItems / perPageTable.value);
});
const updateValues = ref<any>({});
const page = ref(1);
const perPageTable = ref(10);
// let badges = props.headers.filter((f) => f.type == 'badge');

// let pagination = {
//   enabled: true,
//   mode: 'records',
//   perPage: perPageTable.value,
// };

// const computedItems = computed(() => {
//   return props.items.filter(x=> x.archived ? x.archived === 0 : true)
// })

onMounted(() => {
  // page.value = props.page;
  // perPageTable.value = props.perPage;
  // if (props.itemSelect) {
  //   props.headers
  //     .filter((f) => !!f.update)
  //     .map((x) => {
  //       updateValues.value[String(x.update)] = props.itemSelect[String(x.update)];
  //     });
  // }
});
watch(
  () => page.value,
  () => {
    emit('changePage', page.value);
  }
);
watch(
  () => props.page,
  () => {
    page.value = props.page;
  }
);
watch(
  () => perPageTable.value,
  () => {
    emit('changePerPage', perPageTable.value);
  }
);
watch(
  () => props.perPage,
  () => {
    perPageTable.value = props.perPage;
  }
);
watch(
  () => updateValues.value,
  () => {
    emit('updateRow', updateValues.value);
  },
  { deep: true }
);

watch(
  () => search.value,
  () => {
    emit('searching', search.value);
  }
);

// function onSortChange(params) {
//   emit('handleSort', {
//     type: params[0].type,
//     field: params[0].field,
//   });
// }

// watch(
//   () => props.itemSelect,
//   () => {
//     if (props.itemSelect) {
//       updateValues.value = {};

//       const data: any = {};

//       props.headers
//         .filter((f) => !!f.update)
//         .map((x) => {
//           data[String(x.update)] = props.itemSelect[String(x.update)];
//         });
//       updateValues.value = data;
//     }
//   }
// );

function handleBlur(event) {
  emit('blur', event);
}

// function validLine(row) {
//   return props.indexSelect && row.id == props.indexSelect;
// }
function handleUpload() {
  emit('handleUpload');
}
// function onRowClick(params) {
//   emit('rowClick', params);
// }
// function selectionChanged(params) {
//   console.log('selected row', params);
// }

return (_ctx: any,_cache: any) => {
  const _component_VSelect = _resolveComponent("VSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.filters)
      ? (_openBlock(), _createBlock(_unref(MoleculeFilters), {
          key: 0,
          modelValue: search.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
          "has-search": "",
          onHandleUpload: handleUpload,
          onHandleBlur: handleBlur,
          "has-options": props.hasOptions
        }, {
          areaFilter: _withCtx(() => [
            _renderSlot(_ctx.$slots, "areaFilter")
          ]),
          _: 3
        }, 8, ["modelValue", "has-options"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(TreeTable), {
      value: props.items
    }, {
      empty: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.textEmpty), 1)
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((props.headers ?? []).filter(f => f.field != 'actions'), (col, index) => {
          return (_openBlock(), _createBlock(_unref(Column), {
            key: String(index),
            field: col.field,
            header: col.label,
            expander: !!col.expander
          }, null, 8, ["field", "header", "expander"]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((props.headers ?? []).filter(f => f.field == 'actions'), (col, index) => {
          return (_openBlock(), _createBlock(_unref(Column), {
            header: col.label,
            expander: !!col.expander,
            key: String(index)
          }, {
            body: _withCtx((slotProps) => [
              _renderSlot(_ctx.$slots, "actions", {
                data: slotProps.node
              })
            ]),
            _: 2
          }, 1032, ["header", "expander"]))
        }), 128))
      ]),
      _: 3
    }, 8, ["value"]),
    (props.pagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_VSelect, {
              modelValue: perPageTable.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((perPageTable).value = $event)),
              class: "d-flex align-center ms-6",
              items: [10, 15, 20],
              variant: "solo",
              density: "compact"
            }, null, 8, ["modelValue"])
          ]),
          (props.totalItems != 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_unref(MoleculePagination), {
                  class: "pagination-component",
                  modelValue: page.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((page).value = $event)),
                  numberOfPages: lengthItems.value
                }, null, 8, ["modelValue", "numberOfPages"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})